import { render, staticRenderFns } from "./TeamSettingsInvitationRow.vue?vue&type=template&id=688d74d2&scoped=true"
import script from "./TeamSettingsInvitationRow.vue?vue&type=script&lang=js"
export * from "./TeamSettingsInvitationRow.vue?vue&type=script&lang=js"
import style0 from "./TeamSettingsInvitationRow.vue?vue&type=style&index=0&id=688d74d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688d74d2",
  null
  
)

export default component.exports